/*
 * @Author: Tina Huang
 * @Date: 2024-09-02 12:16:32
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-09-14 15:36:48
 * @Description:
 */
import { TypesKey } from '@/constants/creator'
import styles from '../index.module.css'
import luckinLogo from '@/assets/logos/luckin.jpeg'
import xiChaLogo from '@/assets/logos/xicha.jpeg'
import cbdLogo from '@/assets/logos/cbd.png'
import goodmeLogo from '@/assets/logos/goodme.jpg'
import goodmeHi from '@/assets/logos/hi.jpg'
import { QRCode } from 'antd'

export default function Preview(props: any) {
  const { type, formValues } = props
  console.log(formValues)
  const {
    orderCode,
    orderName,
    orderContent,
    orderCus,
    orderMessage,
    orderMode,
    orderStore,
    orderTime,
    orderStep,
    orderPlatfrom,
    orderType,
    orderNumber,
    orderClass,
  } = formValues ?? {}

  if (type === TypesKey.Starbucks) {
    return (
      <div className="shadow-xl w-2/5 rounded-md star">
        <div className={`w-full mt-4 rounded-md p-2 bg-white ${formValues?.['border'] ? styles.borderBox : ''} ${styles.reBox}`} id="node">
          <div className="bg-neutral-700 rounded-md text-white text-center font-bold text-3xl">啡快 {formValues?.['orderNumber']}</div>
          <div className={`flex justify-between items-center ${styles.orderCode}`}>
            <p className={``}>{orderCode}</p>
            <span className="font-bold">1of1</span>
          </div>
          <p className="text-lg">{formValues?.['orderName']}</p>
          <h1 className="text-3xl font-bold">{formValues?.['orderType']}</h1>
          <h1 className="text-3xl font-bold">{formValues?.['orderContent']}</h1>
          <h1 className="text-lg font-bold">{formValues?.['orderEnglish']}</h1>
          <p className="text-sm font-bold">{formValues?.['orderCus']}</p>
          <br />
          <br />
          <p className="text-center font-bold">建议尽快享用，风味更佳</p>
          <p className={`text-center ${styles.orderTime}`}>
            {formValues?.['orderTime']?.split(' ')?.[0]} <strong>{formValues?.['orderTime']?.split(' ')?.[1]}</strong>
          </p>
        </div>
      </div>
    )
  } else if (type === TypesKey.Luckin) {
    return (
      <div className={`shadow-xl rounded-md ${styles.luckin}`} id="node">
        <img src={luckinLogo} className={styles.luckinLogo} alt="" />
        <p>Hi，{formValues?.['orderName']}</p>
        <div className={styles.luckinContent}>
          <h1>{orderCode}</h1>
          <p>{formValues?.['orderMode']}</p>
        </div>
        <p className={styles.luckinName}>{formValues?.['orderContent']}</p>
        <p className={styles.luckinName}>{formValues?.['orderCus']}</p>
        <p className={styles.luckinTime}>
          <strong>{formValues?.['orderTime']}</strong>
          <br></br>
          建议尽快享用，风味更佳
        </p>
      </div>
    )
  } else if (type === TypesKey.Xicha) {
    return (
      <div className={`shadow-xl rounded-md ${styles.xicha}`} id="node">
        <div className={styles.xichaName}>
          <span>{formValues?.['orderClass']}</span>
          Hey，{orderName}
        </div>
        <img src={xiChaLogo} className={styles.xichaLogo} alt="" />
        <h1 className={styles.xichaCode}>{orderCode}</h1>
        <h1 className={styles.xichaContent}>{orderContent}</h1>
        <p className={styles.xichaCus}>{orderCus}</p>
        <div className={styles.xichaMessage}>{orderMessage}</div>
        <p className={styles.xichaTip}>有问题找阿喜，出品不满为你重做</p>
        <div className={styles.xichaFooter}>
          <div className={styles.xichaLeft}>
            <h3>{orderMode}</h3>
            <p>{orderStore}</p>
            <small style={{ fontSize: 10 }}>{orderTime}</small>
            <p style={{ fontSize: 10 }}>建议尽快饮用，风味更佳</p>
          </div>
          <div className={styles.xichaRight}>
            <QRCode value={orderContent} bordered={false} size={70} />
          </div>
        </div>
      </div>
    )
  } else if (type === TypesKey.ChaBaiDao) {
    return (
      <div className={`shadow-xl rounded-md ${styles.chabaidao}`} id="node">
        <div className={styles.cbdHeader}>
          <div className={styles.cbdLeft}>
            <p>{orderPlatfrom}</p>
            <h3>取餐号:{orderNumber}</h3>
            <p>
              <span className={styles.cbdMode}>{orderMode?.split(' ')[0]}</span>
              <span>{orderMode?.split(' ')[1]}</span>
            </p>
            <p style={{ fontSize: 10 }}>{orderTime}</p>
          </div>
          <div className={styles.cbdRight}>
            <QRCode value={orderContent} bordered={false} size={70} />
          </div>
        </div>
        <div className={styles.cbdBody}>
          <h2 className={styles.cbdContent}>
            {orderContent}
            <br></br>
            {orderType}
          </h2>

          <p>做法：{orderCus}</p>
          <p>{orderStep}</p>
        </div>
        <div className={styles.cbdFooter}>
          <div className={styles.cbdFooterLeft}>
            <p>
              <span className={styles.cbdStore}>{orderStore?.split(' ')[0]}</span>
              <span>TEL: {orderStore?.split(' ')[1]}</span>
            </p>
            <div className={styles.cbdTip}>好茶为底，制造新鲜。</div>
          </div>
          <div style={{ paddingTop: 10 }}>
            <img src={cbdLogo} className={styles.cbdLogo} alt="" />
          </div>
        </div>
      </div>
    )
  } else if (type === TypesKey.GoodMe) {
    return (
      <div className={`shadow-xl rounded-md ${styles.goodme}`} id="node">
        <img src={goodmeLogo} className={styles.gmLogo} alt="" />
        <div>
          <span>
            <img src={goodmeHi} className={styles.gmHi} alt="" />
            {orderName}[{orderClass}]
          </span>
        </div>
        <div className={styles.gmHeader}>
          <h1 className={styles.gmCode}>
            {orderNumber}
            <small>{orderMode?.split(' ')[1]}</small>
          </h1>
          <span className={styles.gmMode}>{orderMode?.split(' ')[0]}</span>
        </div>
        <div className={styles.gmContent}>
          <h2>{orderContent}</h2>
          <p>{orderCus}</p>
        </div>
        <div className={styles.gmBox}>
          <div></div>
          <div className={styles.gmBoxRight}>
            <QRCode value={orderContent} bordered={false} size={50} />
          </div>
        </div>
        <div className={styles.gmTip}>{orderMessage}</div>
        <div className={styles.gmFooter}>
          <span>{orderStore?.split(' ')[0]}</span>
          <span>
            {orderStore?.split(' ')[1]} {orderTime}
          </span>
        </div>
      </div>
    )
  }
  return <></>
}
